import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useMarkAsRead() {
  const api = useAxios();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (notifications) => {
      return api.post(`/notifications/read`, { notifications });
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["notifications"] });
      client.invalidateQueries({ queryKey: ["notifications-list"] });
    },
  });
}
